import { IAffairCreateByPlaceApi, IAffairPub } from "@api/affair.int";
import { Place } from "@aws-sdk/client-location";
import { Alert, AlertDescription, AlertIcon, Box, BoxProps, Button, Checkbox, FormControl, FormLabel, Input, InputGroup, InputRightAddon, Link, ListItem, Textarea, UnorderedList, useBoolean, useToast } from "@chakra-ui/react";
import { useVVApi } from "components/api";
import { DeepAuthContext, getGReCaptcha } from "features/auth/DeepAuth";
import { useContext, useEffect, useRef, useState } from "react";
import { TCoordinate } from "@api/api.int";
import { TDataSzolgaltato, useJsonData } from "components/jsonData";
import { DeepErrorBox, DeepErrorContainer } from "components/misc";
import { isLocationAffair, TAffairKind, useVVStore } from "components/store";
import { AFFAIR_DESCRIPTION_MAX, AFFAIR_DESCRIPTION_MIN } from "components/utils";
import { CardContentHead1, VizvButtonBack, VizvButtonPrimary, VizvCard, VizvCardAction, VizvCardActionStrip, VizvCardContent, VizvCardHeader, VizvCardHeader2, VizvMainCol } from "components/vizvComponents";
import { MdClear, MdCloudUpload, MdVerifiedUser } from "react-icons/md";
import { useNavigate } from "react-router";
import { AffairCreateKind } from "./AffairCreateKind";
import { AffairLocation } from "./AffairLocation";
import { AFFAIR_KINDS } from "components/appComponents";
import { AffairCreatePanaszSablon } from "./AffairCreatePanaszSablon";


export type TCreateStage =
	| "AFFAIR_KIND"
	| "LOGIN"
	| "ADDRESS"
	| "DISCLAIMER"
	| "DESCRIPTION"
	| "LOGIN"
	| "CONFIRM"
	| "EMAIL_CONFIRM_NEEDED";


export function AffairCreate() {
	const nav = useNavigate();
	const store = useVVStore();
	const [stage, setStage] = useState<TCreateStage>('AFFAIR_KIND');

	const [isLoading, setIsLoading] = useBoolean();
	const [error, setError] = useState('');

	const [title, setTitle] = useState('');
	const [description, setDescription] = useState('');

	const [place, setPlace] = useState<Place | undefined>();
	const [email, _setEmail] = useState<string>();
	const setEmail = (v: string) => {
		_setEmail(v);
		setEmailState('');
		setError('');
	}
	const [emailState, setEmailState] = useState<'' | 'free' | 'confirmed' | 'not_confirmed' | 'logged_in'>('');

	const authCtx = useContext(DeepAuthContext);
	const api = useVVApi();
	const [isGDPRAccepted, setIsGDPRAccepted] = useState(false);


	useEffect(() => {
		console.log('jelentettCount', authCtx.userAny?.userSummary.jelentettCount, authCtx.signedUser?.status);
		if (authCtx.signedUser && (authCtx.signedUser?.status !== 'C') && authCtx.userAny && (authCtx.userAny?.userSummary.jelentettCount > 0)) {
			console.log('itt...');
			setStage('EMAIL_CONFIRM_NEEDED');
		}
	}, [authCtx.signedUser, authCtx.userAny]);


	useEffect(() => {
		if (stage === 'LOGIN' && authCtx.userConfirmed) {
			setEmailState('logged_in');
			setError('');
		}
	}, [authCtx.userConfirmed, stage])


	// ============================== USER LOGIN ==================================
	const descriptionSubmit = async (e: React.SyntheticEvent) => {
		if (authCtx.userAny) {
			setStage('CONFIRM');
		} else {
			setStage('LOGIN')
		}
	}

	const submitEmail = async (e: React.SyntheticEvent) => {
		e.preventDefault();
		if (!email) {
			setError('Add meg az email címed');
			return;
		}
		setStage('CONFIRM');
	}

	// ============================== FELÍRÁS ==================================
	const toast = useToast();
	const submitAffair = async (e: React.SyntheticEvent) => {
		e.preventDefault();

		if (!place || !place.Geometry || !place.Geometry.Point || !affairKind)
			return;

		if (!authCtx.userAny && !email) {
			alert('no user');
			return;
		}
		setIsLoading.on();
		setError('');
		try {
			const grecaptchaToken = await getGReCaptcha();
			///debugger;
			const resp = await api.fetch<IAffairCreateByPlaceApi>({
				url: '/affair/create-by-place',
				method: 'POST',
				payload: {
					affair: {
						affairKind: affairKind,
						title: title,
						description: description,
						longLat: place.Geometry.Point as TCoordinate,
					},
					email: email || '',
					grecaptchaToken,
				}
			});
			if (resp.signInInfo)
				authCtx.signInWithInfo(resp.signInInfo);
			store.addAffairItems([resp.affair]);
			store.addGroupItems(resp.groups);
			store.resetAfterAction();
			const loc = store.itemsList.find(item => isLocationAffair(item) && item.dbAffair.affairKey === resp.affair.affairKey);
			store.setSuggestionList(loc ? [loc] : []);
			store.addUserSummary('jelentettCount', 1);
			nav('/affair/' + resp.affair.affairKey + '?fresh');
			toast({ title: 'Sikeres bejelentés', status: 'success' });

		} catch (ex) {

			if (('' + ex).startsWith('401')) {
				setEmailState('confirmed');
				setStage('LOGIN');
			} else if (('' + ex).startsWith('402')) {
				setEmailState('not_confirmed');
				setStage('LOGIN');
			} else {
				setError('' + ex);
			}
		} finally {
			setIsLoading.off();
		}
	}



	const addressConfirmReady = (place: Place, locationTitle: string) => {
		console.log('PLACE', place)
		setPlace(place);
		setStage('DISCLAIMER');
		setTitle(locationTitle);
	}

	const [affairKind, setAffairKind] = useState<TAffairKind | null>(null);
	const affairKindSelected = (kind: TAffairKind) => {
		setAffairKind(kind);
		setStage('ADDRESS');
	}
	useEffect(() => {
		if (!affairKind && stage !== 'AFFAIR_KIND' && stage !== 'EMAIL_CONFIRM_NEEDED')
			setStage('AFFAIR_KIND');
	}, [affairKind, stage]);

	// ----------------------------------------------------------------------- json -------------


	const telepData = useJsonData();
	const [szolgaltato, setSzolgaltato] = useState<TDataSzolgaltato | string>("Keresés...");
	useEffect(() => {
		if (!place?.Municipality) {
			setSzolgaltato('Nincs település a címhez!');
			return;
		}
		const telepules = telepData.telepulesByName(place.Municipality);
		if (!telepules) {
			setSzolgaltato(`Nem találom ezt a települést: "${place.Municipality}"`);
			return;
		}
		const szolgaltato = telepData.szolgaltatoByRovidites(telepules.Rövidítés);
		if (!szolgaltato) {
			setSzolgaltato(`Nem találom ezt a szolgáltató rövidítést: "${telepules.Rövidítés}"`);
			return;
		}
		setSzolgaltato(szolgaltato);
	}, [place?.Municipality]);

	const descriptRef = useRef<HTMLTextAreaElement>(null);
	useEffect(() => {
		if (stage === 'DESCRIPTION') {
			window.setTimeout(() => {
				if (descriptRef && descriptRef.current) {
					(descriptRef.current as any).focus();
				}
			}, 300);
		}
	}, [stage])

	// ----------------------------------------------------------------------- HTML -------------
	const [showPanasz, setShowPanasz] = useState(false);

	return <VizvMainCol isTool={stage === 'ADDRESS' ? { width: 400, isDetailed: false } : undefined}  >

		{stage === 'AFFAIR_KIND' && <>
			<AffairCreateKind onSelectKind={affairKindSelected} />
		</>}
		{stage === 'ADDRESS' && affairKind && <AffairLocation
			onCancel={() => setStage('AFFAIR_KIND')}
			newItem={{
				kind: 'Affair',
				subKind: affairKind,
				isNew: true,
				title: 'Jelentem',
			}}

			headStrip={
				<VizvCardHeader2 kind={affairKind || 'vizminoseg'} >Hol tapasztaltad?</VizvCardHeader2>
			}
			onSelect2={addressConfirmReady}
		/>
		}

		{stage === 'DISCLAIMER' && <>
			<VizvCard>
				<VizvCardHeader warning>Figyelem!</VizvCardHeader>
				<VizvCardContent maxW='50em'>
					<UnorderedList className="ulbox" mb={8}>
						<ListItem>
							Ezen az oldalon segítséget nyújtunk a vízszolgáltatással kapcsolatos problémák bejelentéséhez
							, de
						</ListItem>
						<ListItem>
							<b>EZ NEM A HELYI VÍZSZOLGÁLTATÓ HIBABEJELENTÉSI FELÜLETE!</b>
						</ListItem>
						<ListItem>
							A VízVédő honlap célja a tájékoztatás és a vízzel kapcsolatos problémák országos adatbázisba gyűjtése annak érdekében, hogy a Víz Koalíció hatékonyabban tudjon fellépni a biztonságos hazai ivóvízellátás érdekében.
						</ListItem>
					</UnorderedList>
					<CardContentHead1>A területileg illetékes szolgáltató</CardContentHead1>
					{!telepData.isLoaded
						? <Box>Töltögetünk...</Box>
						: <Box>{
							(typeof szolgaltato === 'string')
								? <>{szolgaltato}</>
								: <>

									<ul>
										<li>{szolgaltato['Teljes név']}</li>
										{szolgaltato['Hibabejelentő telefonszám'] && <li><u>Telefon: </u><strong>{szolgaltato['Hibabejelentő telefonszám']}</strong></li>}
										{szolgaltato['Hibabejelentő email cím'] && <li><u>Email: </u><strong>{szolgaltato['Hibabejelentő email cím']}</strong></li>}
										{szolgaltato['Hibabejelentő űrlap'] && <li><u>Bejelentő űrlap: </u><Link className='xx2x' target='_blank' href={szolgaltato['Hibabejelentő űrlap']}>{szolgaltato['Hibabejelentő űrlap']}</Link></li>}
									</ul>
								</>
						}</Box>

					}
					<Box>
						{/*Használd <Link className='xx2' target='_blank' href="https://docs.google.com/document/d/1h8Tx-S6xMB2tF951qJtzqw8v57RfhOx-jte4WBL5GOk/edit?tab=t.0">Panaszlevél sablonunkat</Link> a bejelentéshez.*/}
						{['csotores', 'vizminoseg'].indexOf(affairKind || 'x') !== -1 && <>
							Használd <Link className='xx2' onClick={() => setShowPanasz(true)} >Panaszlevél sablonunkat</Link>
							a bejelentéshez.
						</>}
						<AffairCreatePanaszSablon onClose={() => setShowPanasz(false)} showKind={(showPanasz && affairKind) || undefined} />
					</Box>




				</VizvCardContent>
				<VizvCardActionStrip>
					<VizvButtonBack onClick={() => setStage('ADDRESS')} ml={2} >Vissza</VizvButtonBack>
					<VizvButtonPrimary mr={2} onClick={() => setStage('DESCRIPTION')} protLev="any" >
						Megértettem
					</VizvButtonPrimary>
				</VizvCardActionStrip>
			</VizvCard>
		</>}
		{stage === 'DESCRIPTION' && <>
			<VizvCard>
				<DeepErrorBox error={error} />
				<VizvCardHeader>Eset leírása</VizvCardHeader>
				<form onSubmit={descriptionSubmit}>
					<Box p={2} pt={0} mt={-1}>

						{/*<FormControl>
                            <FormLabel>Kategória</FormLabel>
                            <Input value={affairKind || '???'} />
                        </FormControl>*/}

						Kérjük néhány mondatban írd le a tapasztalatod!
						<FormControl>
							<FormLabel>Címsor</FormLabel>
							<Input value={title} onChange={(e) => setTitle(e.currentTarget.value)} />
						</FormControl>
						<FormControl>
							<FormLabel>Leírás</FormLabel>
							<Textarea
								autoFocus
								ref={descriptRef}
								rows={7} cols={60} value={description} onChange={e => setDescription(e.currentTarget.value)} />
						</FormControl>

						<VizvCardActionStrip>
							<VizvButtonBack onClick={() => setStage('DISCLAIMER')} ml={2} >Vissza</VizvButtonBack>
							<VizvButtonPrimary isDisabled={!place || !description || description.length < AFFAIR_DESCRIPTION_MIN || description.length > AFFAIR_DESCRIPTION_MAX} mr={2}
								isLoading={isLoading} type='submit' protLev="any"
							>Tovább</VizvButtonPrimary>
						</VizvCardActionStrip>
					</Box>
				</form>
			</VizvCard>
		</>}
		{stage === 'LOGIN' && <>
			<VizvCard>
				<DeepErrorBox error={error} />
				<VizvCardHeader>Email cím</VizvCardHeader>
				<form onSubmit={submitEmail}>
					<Box p={2} pt={0} mt={-1}>

						A bejelentéshez meg kell adnod az email-címed!
						<FormControl isRequired={true}>
							<FormLabel>Email címed</FormLabel>
							<InputGroup>
								<Input value={email} type='email' autoComplete='email webauthn'
									//disabled={emailState !== ''}
									onChange={(e) => setEmail(e.currentTarget.value)} />
								<InputRightAddon onClick={() => setEmail('')} cursor='pointer'><MdClear /></InputRightAddon>
							</InputGroup>
						</FormControl>
						<FormControl isRequired={true}>
							<FormLabel>Adatvédelmi szabály elfogadása</FormLabel>
							<Checkbox checked={isGDPRAccepted} onChange={e => setIsGDPRAccepted(e.currentTarget.checked)}>Elfogadom az <Link className="xx2" href="https://www.cka.hu/adatvedelmi-szabalyzat/" target='_blank'>Adatvédelmi szabályzatot</Link></Checkbox>
						</FormControl>

						{(emailState == 'confirmed' || emailState == 'not_confirmed') && <Alert status="error" my={4}><AlertIcon /><AlertDescription>
							Ez az email cím már foglalt!<br />
							Ha hozzád tartozik, kérlek <Button variant='solid' colorScheme='yellow' size='xs' leftIcon={<MdVerifiedUser />} onClick={() => authCtx.showSignIn()} >Jelentkezz be</Button>
						</AlertDescription></Alert>}
						{emailState == 'logged_in' && <Alert status="success" my={4}><AlertIcon /><AlertDescription>
							Sikeresen bejelentkeztél, a "Jelentem" gombra kattintva bejelentheted az ügyet!
						</AlertDescription></Alert>}

						<Box color='InactiveCaptionText' fontSize='sm' my={2}>
							This site is protected by reCAPTCHA and the Google
							<a href="https://policies.google.com/privacy">Privacy Policy</a> and
							<a href="https://policies.google.com/terms">Terms of Service</a> apply.
						</Box>
						<VizvCardActionStrip mt={9}>
							<VizvButtonBack onClick={() => setStage('DESCRIPTION')} ml={2} >Vissza</VizvButtonBack>
							<VizvButtonPrimary mr={2} protLev="any"
								isLoading={isLoading} type='submit'
							>Tovább</VizvButtonPrimary>
						</VizvCardActionStrip>
					</Box>
				</form>
			</VizvCard>
		</>}
		{stage === 'CONFIRM' && <>
			<VizvCard position='relative'>
				<DeepErrorContainer error={error} isLoading={isLoading} onErrorClose={() => setError('')} >
					<VizvCardContent>
						<VizvCardHeader>Bejelentés elküldése</VizvCardHeader>
						<FormLabel>Probléma típusa</FormLabel>
						<ConfirmValue>{AFFAIR_KINDS[affairKind!].name}</ConfirmValue>
						<FormLabel>Helyszín</FormLabel>
						<ConfirmValue>{title}</ConfirmValue>
						<FormLabel>Leírás</FormLabel>
						<ConfirmValue>{description}</ConfirmValue>
					</VizvCardContent>
					<VizvCardActionStrip mt={9} pr={0}>
						<VizvButtonBack onClick={() => setStage('DESCRIPTION')} ml={2} >Vissza</VizvButtonBack>
						<VizvCardAction protLev="any"
							onClick={submitAffair}
						>Bejelentem</VizvCardAction>
					</VizvCardActionStrip>
				</DeepErrorContainer>
			</VizvCard>
		</>}
		{stage === 'EMAIL_CONFIRM_NEEDED' && <>
			<VizvCard position='relative' isClosable>
				<VizvCardHeader>Bejelentés</VizvCardHeader>
				<VizvCardContent>
					<Alert status="error" my={4}><AlertIcon /><AlertDescription>
						Már bejelentettél egy ügyet, de az email-címed még nem erősítetted meg!<br />
						Ha további ügyeket szeretnél bejelenteni, kérleg <Button variant='link' colorScheme='yellow' size='xs' leftIcon={<MdVerifiedUser />} onClick={() => authCtx.showSignIn()} >erősítsd meg az email-címed!</Button>
					</AlertDescription></Alert>
				</VizvCardContent>
			</VizvCard>
		</>}
	</VizvMainCol>
}

export function ConfirmValue({ ...rest }: BoxProps) {
	return <Box {...rest} />
}